// extracted by mini-css-extract-plugin
export default {"root":"ErrorPage_root__lTSAe","image":"ErrorPage_image__lzEQo","image__notfoundtext":"ErrorPage_image__notfoundtext__y0gkv","image__announce":"ErrorPage_image__announce__J+OSq"};